import { ApiPayout } from './index';

export function isPayoutEditable(payout: Pick<ApiPayout, 'state'> | null | undefined) {
  return payout?.state == 'CREATED';
}

export function isPayoutAbortable(payout: Pick<ApiPayout, 'state'> | null | undefined) {
  switch (payout?.state) {
    case 'STARTED':
    case 'PAUSED':
      return true;
    default:
      return false;
  }
}

export function isPayoutProcessing(payout: Pick<ApiPayout, 'state'> | null | undefined) {
  switch (payout?.state) {
    case 'CREATED':
    case 'PAUSED':
    case 'CANCELED':
    case 'COMPLETED':
      return false;
    default:
      return true;
  }
}
